import React, { useState } from "react";
import "./Modal.scss";

interface ChecklistProps {
  items: string[];
  onUpdate: (checkedItems: string[]) => void;
}

export const Checklist: React.FC<ChecklistProps> = ({ items, onUpdate }) => {
  const [checkedItems, setCheckedItems] = useState<string[]>([]);

  const handleCheck = (item: string) => {
    const newChecked = checkedItems.includes(item)
      ? checkedItems.filter(i => i !== item)
      : [...checkedItems, item];
      
    setCheckedItems(newChecked);
    onUpdate(newChecked);
  };

  return (
    <div className="checklist">
      {items.map(item => (
        <label key={item} className="checklist-item">
          <input
            type="checkbox"
            checked={checkedItems.includes(item)}
            onChange={() => handleCheck(item)}
          />
          {item}
        </label>
      ))}
    </div>
  );
};
